<template>	
    <b-container fluid v-if="totalLiquidacion != null">
        <b-row>
            <b-col class="card-form-purple mt-5 " v-if="datosPago!=null">
                <b-row>
                    <b-col class="mt-3 mb-2" cols="12">
                        <h5 style="color: #2A59B7;"><b-icon icon="menu-button-wide-fill"/> Datos del pago</h5>
                    </b-col>
                    <b-col >
                        <b-table  style="max-height:500px; font-size:12px;" class="text-left" thead-class="hidden_header" small :items="datosPago">
                            <template v-slot:cell(nombre)="row" >                
                                <span v-if="row.item.nombre!='Subsidio aplicado'">{{row.item.nombre}}</span>
                                <span v-if="row.item.nombre=='Subsidio aplicado'" style="color:black"><b>{{row.item.nombre}}</b></span>
                            </template>
                            <template v-slot:cell(detalle)="row" >                
                                <span v-if="row.item.nombre!='Subsidio aplicado'">{{row.item.detalle}}</span>
                                <span v-if="row.item.nombre=='Subsidio aplicado'" style="color:green"><b>{{row.item.detalle}}</b></span>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </b-col>
            
        </b-row>
        <b-row>
            <b-col class="card-form-blue mt-5">
                <b-row align-h="between">
                    <b-col class="mt-3 mb-2" cols="8">
                        <h5 style="color: #2A59B7;" ><b-icon icon="table"/> Liquidación</h5>
                    </b-col>

                    <b-col align="end" class="mt-3 mb-2" cols="4" v-if="!mostrarDetalle">
                        <b-icon icon="chevron-bar-left" style="cursor:pointer; color:gray;"  @click="mostrarDetalle=true"/>
                         <b-icon icon="chevron-bar-right" style="cursor:pointer; color:gray;"  @click="mostrarDetalle=true"/>
                    </b-col>
                     <b-col align="end" class="mt-3 mb-2" cols="4" v-if="mostrarDetalle" >
                        <b-icon icon="chevron-bar-right" style="cursor:pointer; color:gray;" @click="mostrarDetalle=false"/>
                        <b-icon icon="chevron-bar-left" style="cursor:pointer; color:gray;" @click="mostrarDetalle=false"/>
                    </b-col>

                    <b-col class=" mt-1" cols="12">
                        <b-table style="max-height:500px; font-size:12px; " class="table-sticky"
                            selectable responsive stacked="sm" :fields="fields" striped small 
                            :items="parcialidadesLiq" :busy="isCalculando" 
                            >
                            
                            <template v-slot:table-busy>
                                <div class="text-center text-danger my-2">
                                <b-spinner style="width: 3rem; height: 3rem;" class="align-middle"/>
                                <strong>  Cargando . . . </strong>
                                </div>
                            </template>



                            <template v-slot:cell(pagar)="row">
                                <!-- Si la liquidacion se obtuvo de una orden de pago o si la liquidacion se obtuvo de un servicio externo o si la liquidacion es de mas de una categoria de conceptos se desabilita-->
                                <b-form-checkbox 
                                :disabled="(formModel!=null  && (formModel.itemSelected==$OrdenPagoItem || formModel.itemSelected=='Integración IUSA')) || liqForms.length>1 "  
                                style="margin-bottom:-3px;" size="lg" 
                                v-model="row.item.pagar" 
                                :id="row.item.idxParcialidad.toString()" 
                                @change="getLiquidacionForm(row.item.idxParcialidad)" />
                            </template>

                            <template v-slot:cell(detalles)="row" >                
                                <h4 style="margin-bottom:-3px;  margin-right:8px; cursor:pointer;">
                                    <b-icon 
                                    v-if="liqForms!=null && liqForms.length>1 && (formModel!=null  && (formModel.itemSelected!=$OrdenPagoItem && formModel.itemSelected!='Integración IUSA')) "
                                    @click="getLiquidacionQuitaConcepto(row.index)"  icon="trash-fill" font-scale=".8" variant="danger"/>
                                    
                                    <b-icon @click="showDetalles" icon="plus-circle-fill" :id="row.item.idxParcialidad" variant="success"/> 
                                </h4>
                            </template>

                            <template v-slot:cell(concepto)="row" >                
                                <span v-if="tipoVista!='acumulada'">{{row.item.concepto}}</span>
                                <b @click="row.toggleDetails" v-if="tipoVista=='acumulada'">{{row.item.concepto}}</b>
                            </template>

                            <template #row-details="row">
                                <b-card>
                                <b-row class="mb-2">
                                    <b-col>
                                        <b-table                                         
                                             responsive stacked="sm" :fields="fields"  small 
                                            :items="parcialidadesPorPeriodo[row.item.periodo]"  
                                            >
                                            
                                            <template v-slot:cell(pagar)="inRow">
                                                <b-form-checkbox 
                                                disabled  
                                                style="margin-bottom:-3px;" size="sm" 
                                                v-model="inRow.item.pagar" 
                                                :id="inRow.item.idxParcialidad.toString()"  />
                                            </template>

                                            <template v-slot:cell(detalles) >                
                                                <h4 style="margin-bottom:-3px;  margin-right:8px; cursor:pointer;">
                                                    
                                                </h4>
                                            </template>

                                        </b-table>
                                    </b-col>
                                </b-row>
                                </b-card>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>


                <b-row align="end" v-if="resumen!=null && mostrarDetalle">
                    <b-col cols="12" v-if="resumen.importe!=null" @click="isShowModalDetalleImporte=true" style="cursor:pointer;">
                        <b style="font-size:15px;color: #33374B">Importe: </b><b style="font-size:15px;color: #A0989B"> $ {{resumen.importe}}</b>
                    </b-col>
                     <b-col cols="12" v-if="resumen.actualizacion!=null">
                        <b style="font-size:15px;color: #33374B">Actualizaciónes: </b><b style="font-size:15px;color: #A0989B"> $ {{resumen.actualizacion}}</b>
                    </b-col>
                     <b-col cols="12" v-if="resumen.recargo!=null">
                        <b style="font-size:15px;color: #33374B">Recargos: </b><b style="font-size:15px;color: #A0989B"> $ {{resumen.recargo}}</b>
                    </b-col>
                     <b-col cols="12" v-if="resumen.multa!=null">
                        <b style="font-size:15px;color: #33374B">Multas: </b><b style="font-size:15px;color: #A0989B"> $ {{resumen.multa}}</b>
                    </b-col>
                     <b-col cols="12" v-if="resumen.pae!=null">
                        <b style="font-size:15px;color: #33374B">PAE: </b><b style="font-size:15px;color: #A0989B"> $ {{resumen.pae}}</b>
                    </b-col>
                     <b-col cols="12" v-if="resumen.iva!=null">
                        <b style="font-size:15px;color: #33374B">IVA: </b><b style="font-size:15px;color: #A0989B"> $ {{resumen.iva}}</b>
                    </b-col>
                     <b-col cols="12" v-if="resumen.subsidios!=null">
                        <b style="font-size:15px;color: #33374B">Subsidios: </b><b style="font-size:15px;color: #A0989B"> $ {{resumen.subsidios}}</b>
                    </b-col>
                </b-row> 

                <b-row align="end" class="mb-3">
                    <b-col class="mb-3" >
                        <b style="font-size:20px;color: #2A59B7; cursor:pointer;" @click="isShowModalRedondeo=true">Total: </b>
                        <b style="font-size:20px;color: #F94A5A; cursor:pointer;" @click="isShowModalRedondeo=true"> $ {{totalLiquidacion}}</b>
                    </b-col>
                </b-row>
                
            </b-col>
            
        </b-row>
        <!--  MODALS -->
        <b-modal v-model="isShowModalDetalles" title="Detalle del pago" hide-footer header-bg-variant="dark" header-text-variant="light" size="lg">
            <div>
                <b-row style="border-bottom: 1px #EFEFEF solid;" v-for="(detalle, idx) in contenidoModalDetalles" :key="idx"> <b-col cols="4"><b>{{detalle.split(':')[0]}}</b></b-col><b-col>{{detalle.split(':')[1]}}</b-col></b-row>

                <b-row class="mt-5"><b-col><b style="color:gray;"><h5><b-icon icon="cash-stack"/> Liquidación</h5></b></b-col></b-row>
                <b-row class="mt-3" v-if="ultParcialidadConsultada!=null">
                    <b-col cols="5"><b>Periodo:</b> </b-col>
                    <b-col cols="5"><b> {{ultParcialidadConsultada.periodo}}</b></b-col>
                    <b-col cols="5"><b>Monto:</b> </b-col>
                    <b-col cols="5"> {{ultParcialidadConsultada.importe}}</b-col>
                    <b-col cols="5"><b>Actualización:</b> </b-col>
                    <b-col cols="5"> {{ultParcialidadConsultada.actualizacion}}</b-col>
                    <b-col cols="5"><b>Recargo:</b> </b-col>
                    <b-col cols="5"> {{ultParcialidadConsultada.recargo}}</b-col>
                    <b-col cols="5"><b>Multa:</b> </b-col>
                    <b-col cols="5"> {{ultParcialidadConsultada.multa}}</b-col>
                    <b-col cols="5"><b>PAE:</b> </b-col>
                    <b-col cols="5"> {{ultParcialidadConsultada.pae}}</b-col>
                    <b-col cols="5"><b>I.V.A.:</b> </b-col>
                    <b-col cols="5"> {{ultParcialidadConsultada.iva}}</b-col>
                    <b-col cols="5"><b>Subsidio:</b> </b-col>
                    <b-col cols="5"> {{ultParcialidadConsultada.subsidios}}</b-col>
                    <b-col cols="5"><b>Total:</b> </b-col>
                    <b-col cols="5"><b> {{ultParcialidadConsultada.total}}</b></b-col>
                </b-row>


                <b-row class="mt-3" v-if="ultParcialidadConsultada!=null && ultParcialidadConsultada.advertencias!=null && ultParcialidadConsultada.advertencias!=''">
                    <b-col cols="12"><b style="color:red;"><h6><b-icon icon="exclamation-square-fill"/> Se encontrarón las siguientes inconsistencias al liquidar</h6></b></b-col>
                    <b-col cols="12">
                        <b-form-textarea
                            v-model="ultParcialidadConsultada.advertencias"
                            rows="2"
                            max-rows="3"
                            :disabled="true"
                        ></b-form-textarea>
                    </b-col>
                </b-row>

                <!-- //<b-row v-if="permisoExentar && formModel!=null  && formModel.itemSelected!=$OrdenPagoItem && liqForms.length<1 && formModel.itemSelected!='Integración IUSA'" class="mt-5"> -->
                <b-row v-if="permisoExentar && formModel!=null  && formModel.itemSelected!=$OrdenPagoItem && liqForms.length<2 && formModel.itemSelected!='Integración IUSA'" class="mt-5">
                    <b-col cols="12">
                        <b-form-checkbox v-model="showExenta">Exentar/Registrar Pago</b-form-checkbox>
                    </b-col>
                </b-row>
                <b-row v-if="showExenta">
                    <b-col cols="12">
                        Ingresa el fundamento/observación
                        <b-form-input v-model="fundamento" size="sm"></b-form-input>
                    </b-col>
                    <b-col>
                        <b-button @click="exentaPeriodo" variant="success" size="sm">Guardar <b-icon icon="cloud-check-fill"/></b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal hide-footer title="Detalle Importe" v-model="isShowModalDetalleImporte" header-bg-variant="dark" header-text-variant="light">
            <b-row align-h="center" align="center">
                <b-col v-if="resumen!=null && resumen.impteAñoActual!=null">
                    <b-row  class="mb-2 mt-2">
                        <b-col cols="12"><b>Año Actual: $</b> {{resumen.impteAñoActual}}</b-col>
                        <b-col cols="12"><b>Años Anteriores: $</b> {{resumen.impteAñosAtras}}</b-col>
                    </b-row>
                </b-col>            
            </b-row>
        </b-modal>

        <b-modal hide-footer title="Redondeo" v-model="isShowModalRedondeo" header-bg-variant="dark" header-text-variant="light">
            <b-row align-h="center" align="center">
                <b-col>
                    <b-button @click="getLiquidacionSinRedondeo()">Aplicar/Quitar redondeo</b-button>
                </b-col>            
            </b-row>
        </b-modal>

    </b-container>
</template>

<script>
    import axios from 'axios'
    import { server, checkAuth, getPostConfig, handledError } from '@/axios-tools'
    import { mapState} from 'vuex'

  export default {
    props:['parcialidades', 'totalLiquidacion', 'datosPago', 'getLiquidacion', 'getLiquidacionSin', 'resumen', 'tipoVista'],
    data() {
      return {
        isShowModalDetalles: false,
        contenidoModalDetalles:"",
        fundamento:"",
        ultPeriodoConsultado:"",
        ultPeriodoClaveConsultada:-1,
        ultParcialidadConsultada:null,
        showExenta:false,
        mostrarDetalle:true,
        isShowModalDetalleImporte:false,
        isShowModalRedondeo:false,
        quitarRedondeo:false
      }
    },
    
    computed:  {
      ...mapState({
        /*parcialidades: state => state.cobro.parcialidades,
        totalLiquidacion: state => state.cobro.totalLiquidacion,
        datosPago: state => state.cobro.datosPago,*/
        isCalculando: state => state.cobro.isCalculando,
        isGenerando: state => state.cobro.isGenerando,
        permisoExentar: state => state.cobro.permisoExentar,
        formModel : state => state.cobro.formModel,
        token: state => state.login.token,
        liqForms: state => state.cobro.formsModels,
        msgErrorLiquidacion: state => state.cobro.msgErrorLiquidacion
        }),
        parcialidadesLiq:function(){
            return this.tipoVista =='acumulada' ?
            this.parcialidadesAcumuladas:
            this.parcialidades;
        },
        parcialidadesAcumuladas:function(){
            let pAcumuladas = {};
            let ft = new Intl.NumberFormat('es-MX',{minimumSignificantDigits: 2});
            for(let idx in this.parcialidades){
                let parcialidad = this.parcialidades[idx];
                let periodo = parcialidad.periodo;
                let pAcumulada = pAcumuladas[periodo];
                if(pAcumulada ==null){
                    const concepto = parcialidad.concepto;
                    pAcumuladas[periodo] = {
                        idxParcialidad : parcialidad.idxParcialidad,
                        concepto : concepto,
                        base : parcialidad.base,
                        periodo : parcialidad.periodo,
                        importe: parcialidad.importe,
                        actualizacion:parcialidad.actualizacion,
                        importeAct:parcialidad.importeAct,
                        recargo:parcialidad.recargo,
                        multa:parcialidad.multa,
                        pae:parcialidad.pae,
                        iva:parcialidad.iva,
                        subsidios:parcialidad.subsidios,
                        total:parcialidad.total,
                        detalles:parcialidad.detalles,
                        advertencias:parcialidad.advertencias,
                        pagar : parcialidad.pagar
                    };
                    
                }else{
                    pAcumulada.idxParcialidad = parcialidad.idxParcialidad; //Se actualiza la ultima

                    if((pAcumulada.concepto + ', '+parcialidad.concepto).length <50){
                        pAcumulada.concepto =   pAcumulada.concepto + ', '+parcialidad.concepto;
                        pAcumulada.concepto = pAcumulada.concepto.replace(' DE AGUA POTABLE','').replace('SERVICIO DE ','').replace(' DE AGUAS RESIDUALES','');
                    }

                    pAcumulada.base=       
                        ft.format(( Math.round((+(pAcumulada.base.replace(',', '')))*100) + Math.round((+(parcialidad.base.replace(',', '')))*100) )/100);

                    
                    pAcumulada.importe=       
                        ft.format(( Math.round((+(pAcumulada.importe.replace(',', '')))*100) + Math.round((+(parcialidad.importe.replace(',', '')))*100) )/100);

                    pAcumulada.actualizacion= 
                        ft.format(( Math.round((+(pAcumulada.actualizacion.replace(',', '')))*100) + Math.round((+(parcialidad.actualizacion.replace(',', '')))*100) )/100);

                    pAcumulada.importeAct=  
                        ft.format(( Math.round((+(pAcumulada.importeAct.replace(',', '')))*100) + Math.round((+(parcialidad.importeAct.replace(',', '')))*100) )/100);

                    pAcumulada.recargo=     
                        ft.format(( Math.round((+(pAcumulada.recargo.replace(',', '')))*100) + Math.round((+(parcialidad.recargo.replace(',', '')))*100) )/100);

                    pAcumulada.multa=       
                        ft.format(( Math.round((+(pAcumulada.multa.replace(',', '')))*100) + Math.round((+(parcialidad.multa.replace(',', '')))*100) )/100);

                    pAcumulada.pae=         
                        ft.format(( Math.round((+(pAcumulada.pae.replace(',', '')))*100) + Math.round((+(parcialidad.pae.replace(',', '')))*100) )/100);

                    pAcumulada.iva=         
                        ft.format(( Math.round((+(pAcumulada.iva.replace(',', '')))*100) + Math.round((+(parcialidad.iva.replace(',', '')))*100) )/100);

                    pAcumulada.subsidios=   
                        ft.format(( Math.round((+(pAcumulada.subsidios.replace(',', '')))*100) + Math.round((+(parcialidad.subsidios.replace(',', '')))*100) )/100);

                    pAcumulada.total=       
                    ft.format(( Math.round((+(pAcumulada.total.replace(',', '')))*100)  + Math.round((+(parcialidad.total.replace(',', '')))*100) )/100);
                    
                }
            }
            return Object.values(pAcumuladas);
        },
        parcialidadesPorPeriodo:function(){
            let parcialidadesPeriodos = {};
            for(let idx in this.parcialidades){
                let parcialidad = this.parcialidades[idx];
                let periodo = parcialidad.periodo;
                let parcialidadesPeriodo = parcialidadesPeriodos[periodo];
                if(parcialidadesPeriodo ==null){
                    parcialidadesPeriodo = [];
                    parcialidadesPeriodos[periodo] = parcialidadesPeriodo;
                }
                parcialidadesPeriodo.push(parcialidad);    
            }
            return parcialidadesPeriodos;
        },
        fields: {
            get: function(){
                if(this.mostrarDetalle){
                     var fieldsD=[            
                        { key: 'concepto', label: 'Concepto' },
                        { key: 'periodo', label: 'Periodo' },                       
                    ];
                    if(this.resumen!=null && this.resumen.base!=null){
                        fieldsD.push({ key: 'base', label: this.resumen.base, thClass: 'text-right', tdClass: 'text-right'});
                    }
                    if(this.resumen!=null && this.resumen.importe!=null){
                        fieldsD.push({ key: 'importe', label: 'Importe', thClass: 'text-right', tdClass: 'text-right'});
                    }
                    if(this.resumen!=null && this.resumen.actualizacion!=null){
                        fieldsD.push({ key: 'actualizacion', label: 'Act', thClass: 'text-right', tdClass: 'text-right'});
                    }
                    if(this.resumen!=null && this.resumen.recargo!=null){
                        fieldsD.push({ key: 'recargo', label: 'Recargo', thClass: 'text-right', tdClass: 'text-right'});
                    }
                    if(this.resumen!=null && this.resumen.multa!=null){
                        fieldsD.push({ key: 'multa', label: 'Multa', thClass: 'text-right', tdClass: 'text-right'});
                    }
                    if(this.resumen!=null && this.resumen.pae!=null){
                        fieldsD.push({ key: 'pae', label: 'PAE', thClass: 'text-right', tdClass: 'text-right'});
                    }
                    if(this.resumen!=null && this.resumen.iva!=null){
                        fieldsD.push({ key: 'iva', label: 'IVA', thClass: 'text-right', tdClass: 'text-right'});
                    }
                    if(this.resumen!=null && this.resumen.subsidios!=null){
                        fieldsD.push({ key: 'subsidios', label: 'Subsidios', thClass: 'text-right', tdClass: 'text-right'});
                    }
                    fieldsD.push({ key: 'total', label: 'Total', thClass: 'text-right', tdClass: 'text-right'});
                    fieldsD.push({ key: 'pagar', label: 'Pagar', thClass: 'text-right', tdClass: 'text-right'});
                    fieldsD.push({ key: 'detalles', label: 'Detalle' , thClass: 'text-right', tdClass: 'text-right'});
                    return fieldsD;
                }else{
                    var fieldsS=[            
                        { key: 'concepto', label: 'Concepto' },
                        { key: 'periodo', label: 'Periodo' },
                        { key: 'total', label: 'Total' , thClass: 'text-right', tdClass: 'text-right'},
                        { key: 'pagar', label: 'Pagar', thClass: 'text-right', tdClass: 'text-right'},
                        { key: 'detalles', label: 'Detalle', thClass: 'text-right', tdClass: 'text-right'},
                    ];
                    return fieldsS;
                }
            }
        },        
    },
    methods: {
        getLiquidacionForm(idxSelected){
            if(this.formModel!=null){
                this.getLiquidacion(false, true, idxSelected);//no es orden, liquidacion nueva, ultimo indice seleccionado
            }else{
                this.getLiquidacion(idxSelected);// ultimo indice seleccionado
            }
            
        },
        showDetalles(event){
            if(!this.isCalculando && !this.isGenerando){
                var idxParcialidad = event.currentTarget.id;
                for(let idxTable in this.parcialidadesLiq){
                    if(idxParcialidad == this.parcialidadesLiq[idxTable].idxParcialidad){
                        this.ultPeriodoConsultado = this.parcialidadesLiq[idxTable].periodo;
                        this.ultPeriodoClaveConsultada = this.parcialidadesLiq[idxTable].clave;
                        this.ultParcialidadConsultada = this.parcialidadesLiq[idxTable];
                        this.contenidoModalDetalles = this.parcialidadesLiq[idxTable].detalles;
                        this.isShowModalDetalles = true;
                    }
                }                
            }
        },
        // indexOfTableLiq (periodo){
        //     for (var index in this.parcialidades){
        //         if(this.parcialidades[index].periodo == periodo){
        //             return index;
        //         }
        //     }
        //     return -1;
        // },
        exentaPeriodo(){
            if(!this.isCalculando && !this.isGenerando && checkAuth(this.$router, this.$store)){
                this.isShowModalDetalles = false;
                this.$store.commit("updateIsCalculando", true);
                var body={
                    periodoExentable: this.ultPeriodoConsultado,
                    fundamento: this.fundamento,
                    liqForms: this.liqForms,
                    claveCobro : this.ultPeriodoClaveConsultada
                }
                axios(
                    getPostConfig(server.exentaPeriodo, body, this.token, {})            
                        ).then(() => {
                            this.$store.commit("updateIsCalculando", false);
                            this.getLiquidacionForm(999);
                        }).catch(err => {
                            this.$store.commit("updateIsCalculando", false);
                            handledError(err, server.exentaPeriodo, this.$router, this.$store);
                        })
                this.fundamento=""
                this.ultPeriodoConsultado=""
                this.ultPeriodoClaveConsultada = -1;
                this.ultParcialidadConsultada = null
                this.showExenta=false
            }
        },
        getLiquidacionSinRedondeo(){
            this.quitarRedondeo= !this.quitarRedondeo;

            if(this.liqForms !=null){
                for(const idx in this.liqForms){
                    this.liqForms[idx].quitarRedondeo = this.quitarRedondeo;
                }
            }
            if(this.formModel!=null){
                this.formModel.quitarRedondeo = this.quitarRedondeo;
            }
            this.getLiquidacionForm(9999);
            this.isShowModalRedondeo = false;

            
        },
        getLiquidacionQuitaConcepto(idx){
                
            if(this.liqForms !=null ){
                this.liqForms.splice(idx, 1);
            }
            
            this.getLiquidacionSin();
            
            
        }			        
    },
  }

</script>
<style >
.hidden_header {
  display: none;
}
.table-sticky thead th {
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 10;
}
</style>